import { Mixins, Component } from 'vue-property-decorator';
import { EventBus, HttpErrorEvent } from '@/services/event-bus';
import { ApplicationError } from '@/models/errors/application-error';

declare module 'vue/types/vue' {
    interface Vue {
        $notifyCreated()
        $notifyUpdated()
        $notifyDeleted(text: string)
        $notifySuccess(text: string)
        $notifyError(errors: ApplicationError)
    }
}

export interface INotificationComponent {
    notificationText: any;
}

@Component
export default class ActionNotificationMixin extends Mixins() {
    private get isInstanceOfINotificationComponent(): boolean {
        return this.notificationComponent.notificationText !== undefined
    }

    private get notificationComponent(): INotificationComponent {
        return (this.$vnode.componentInstance as any) as INotificationComponent
    }

    $notifyCreated() {
        this._notify('Successfully Created!')
    }

    $notifyUpdated() {
        this._notify('Successfully Changed!')
    }

    $notifyDeleted(title: string) {
        this.$notifySuccess(`${title} - Successfully Deleted!`);
    }

    $notifySuccess(text: string) {
        this.$notify({
            group: 'action-notifications',
            title: 'Success',
            text,
            duration: 3500,
            type: 'success',
        });
    }

    $notifyError(errors: ApplicationError) {
        EventBus.$emit(HttpErrorEvent, errors)
    }

    private _notify(textKey: string) {
        if (!this.isInstanceOfINotificationComponent) { return; }

        const notificationText = this.notificationComponent.notificationText;
        const text = notificationText
            ? `${notificationText} - ${textKey}`
            : textKey

        this.$notifySuccess(text);
    }
}
